import { useGlobal } from '@/utils/useGlobal';
import BackToTop from '@elem/compCommon/BackToTop';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';

export default function IndexDynamic() {
    const { useState, useLang, useRouter, useEffect, gtm } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [isClient, setIsClient] = useState(false);
    const [visible, setVisible] = useState(false);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_list1_title'), link: '#power-independence-D' },
            { text: t('secC_list2_title'), link: '#power-independence-F' },
            { text: t('secC_list3_title'), link: '#power-independence-J' },
        ],
    };

    const handleAddCart = (card: ShopifyCartItemType) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card.title,
            list_name: 'none',
            price: card?.discountPrice,
            tag: 'none',
            quantity: shoppingCarts.length + 1,
            button_name: t('common_card_buy'),
        });
        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            // setShoppingCarts([
            //     obj,
            //     ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            // ]);
            EcoDesignEventsBus.emit('eco-cart-add', [
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            //setShoppingCarts([obj, ...shoppingCarts]);
            EcoDesignEventsBus.emit('eco-cart-add', [obj, ...shoppingCarts]);
        }
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const NEW_SITE = ['de', 'eu', 'uk', 'it', 'es'];
    const SHOW_NEW_SITE = NEW_SITE.includes(locale);

    const HIDE_N_SITE = ['eu'];
    const HIDE_N = HIDE_N_SITE.includes(locale);

    // 隐藏 POWER_STREAM
    const HIDE_POWER_STREAM_SITE = ['uk'];
    const HIDE_PS = HIDE_POWER_STREAM_SITE.includes(locale);

    // 隐藏 POWER_OCEAN
    const HIDE_POWER_OCEAN_SITE = ['it', 'es'];
    const HIDE_PO = HIDE_POWER_OCEAN_SITE.includes(locale);

    const HIDE_I_SITE = ['it', 'es'];
    const HIDE_I = HIDE_I_SITE.includes(locale);

    return (
        <>
            {SHOW_NEW_SITE && <P />}
            <C />
            {!SHOW_NEW_SITE && (
                <>
                    <D />
                    <E />
                </>
            )}
            {!HIDE_PS && (
                <>
                    <F />
                    <G />
                </>
            )}
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.PowerIndependence}
                entry_position={locale === 'uk' ? 4 : locale === 'fr' ? 7 : 6}
            />
            {SHOW_NEW_SITE && (
                <>
                    {!HIDE_PS && <H />}
                    {!HIDE_PO && (
                        <>
                            <D />
                            <E />
                            <B />
                        </>
                    )}
                </>
            )}
            <J />
            <K callBuy={handleAddCart} />
            {SHOW_NEW_SITE && !HIDE_I && <I />}
            <L />
            <M />
            {!HIDE_N && <N />}
            <O />
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.body)}
        </>
    );
}
